import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';

import * as yup from 'yup';

export interface DocumentsStatisticsFindInterface {
  /** Income documents with cash method total amount */
  kassIncomeAmount: number;
  /** Expense documents with cash method total amount */
  kassExpenseAmount: number;
  /** Income and expense documents with cash method total amount difference */
  kassDiff: number;
  /** Income documents with sale method total amount */
  saleIncomeAmount: number;
  /** Expense documents with sale method total amount */
  saleExpenseAmount: number;
  /** Income and expense documents with sale method total amount difference */
  saleDiff: number;
}

export const DocumentsStatisticsFindDto = SerdeDtoClass.create<DocumentsStatisticsFindInterface>(BusinessDtoKeysEnum.DOCUMENT_STATISTIC_FIND_DTO, {
  kassIncomeAmount: {
    sortable: true,
    label: 'Кассовая сумма дохода',
    serializer: yup.number(),
  },
  kassExpenseAmount: {
    sortable: true,
    label: 'Кассовая сумма расходов',
    serializer: yup.number(),
  },
  kassDiff: {
    sortable: true,
    label: 'Разница',
    serializer: yup.number(),
  },
  saleIncomeAmount: {
    sortable: true,
    label: 'Сумма дохода от продажи',
    serializer: yup.number(),
  },
  saleExpenseAmount: {
    sortable: true,
    label: 'Сумма расходов на продажу',
    serializer: yup.number(),
  },
  saleDiff: {
    sortable: true,
    label: 'Разница продажи',
    serializer: yup.number(),
  },
});
